import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ThemeProvider } from './components/ThemeProvider';

// Importowanie komponentów
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Portfolio from './components/Portfolio';
//import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

import CtaSection from './components/CtaSection';
import ScrollProgress from './components/ScrollProgress';
import CookieConsent from './components/CookieConsent';
import NotFound from './components/NotFound';

// Główny komponent aplikacji
function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem>
      <Router>
        <div className="bg-background text-foreground min-h-screen">
          <ScrollProgress color="primary" showButton={true} buttonPosition="right" />
          <Navbar />
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            <Routes>
              <Route path="/" element={
                <>
                  <Hero />
                  <Services />
                  {/* Umieść CTA między sekcjami */}
                  <CtaSection 
                    variant="primary" 
                    title="IT For Everyone - technologia przyjazna dla Twojego biznesu" 
                    subtitle="Proste, przejrzyste i skuteczne rozwiązania IT dla Twojej firmy"
                    features={[
                      "Zrozumiałe rozwiązania", 
                      "Indywidualne podejście", 
                      "Przystępne ceny", 
                      "Wsparcie techniczne"
                    ]}
                  />
                  
                  <About />
                  
                  {/* Można również umieścić inną wersję CTA w innym miejscu */}
                  <CtaSection 
                    variant="success" 
                    title="Rozpocznij swoją przygodę z IT już dziś" 
                    buttonText="Konsultacja"
                    showStats={true}
                  />
                  <Portfolio />
                  {/*<Testimonials />*/}
                  <Contact />
                </>
              } />
              <Route path="/uslugi" element={<Services />} />
              <Route path="/o-nas" element={<About />} />
              <Route path="/portfolio" element={<Portfolio />} />
              {/*<Route path="/opinie" element={<Testimonials />} />*/}
              <Route path="/kontakt" element={<Contact />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </motion.div>
          <Footer />
          <CookieConsent 
            position="bottom" 
            theme="dark" 
            compactOnMobile={true} 
          />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;